import api from '@api'
import Constants from '@constants'

import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@/src/utils/get-module-translator'

import {
  transformLinkAssetIdsForServer,
  transformLinkCiIdsForServer,
} from '@data/ticket'

const __rootTc = getRootPluaralTranslator()
const __rootT = getRootTranslator()

export function bulkAddRelationApi(moduleName, id, relatedIds, targetModule) {
  return api.post(
    `cportal/${moduleName}/${id}/relation/bulk/create`,
    {
      ...(targetModule === Constants.CMDB
        ? {
            linkCiIds: transformLinkCiIdsForServer({
              linkCiIds: relatedIds,
            }),
          }
        : {
            linkAssetIds: transformLinkAssetIdsForServer({
              linkAssetIds: relatedIds,
            }),
          }),

      type: 'related',
    },
    {
      message: __rootT('added_successfully', {
        resource: __rootTc('relation', relatedIds.length),
      }),
    }
  )
}

export function getRelationsApi(
  sourceModuleName,
  sourceId,
  targetModuleName,
  type = undefined,
  limit,
  offset,
  additionalUrlParams = {}
) {
  return api
    .get(
      `cportal/${sourceModuleName}/${sourceId}/relation/get/${targetModuleName}`,
      {
        params: {
          type,
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
          ...additionalUrlParams,
        },
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map((relation) => ({
          ...relation.obj,
          relationId: relation.id,
          relationType: relation.type,
        })),
        total: data.totalCount,
      }
    })
}

export function deleteRelationApi(relationId) {
  return api.delete(`cportal/relation/${relationId}`, {
    message: __rootT('removed_successfully', {
      resource: __rootTc('relation'),
    }),
  })
}
